import React from 'react';
import { HexColorPicker, HexColorInput } from 'react-colorful';
import { Popover } from 'antd';
import './color-picker.less';

const ColorPickerPopoverContent = ({ value, onChange }) => (
  <div className="color-picker-popover">
    <HexColorPicker color={value} onChange={onChange} />
    <HexColorInput prefixed color={value} onChange={onChange} />
  </div>
);

const ColorPicker = ({ value, label, onChange, disabled }) => (
  <div className={`color-picker${disabled ? ' disabled' : ''}`}>
    <Popover trigger={disabled ? 'hover' : 'click'} content={disabled ? 'Select custom theme to change colors' : <ColorPickerPopoverContent value={value} onChange={onChange} />}>
      <div
        className="swatch"
        style={{ backgroundColor: value }}
        role="button"
        tabIndex={0}
      />
    </Popover>
    <div className="color-picker__label">
      {label}
    </div>
  </div>
);

export default ColorPicker;
